<template>
  <div v-if="ordreTravail">
    <div class="entete border-entete">
      <div class="is-paddingless section">
        <div class="level">
          <div class="level-left">
            <div class="columns is-gapless">
              <div class="column">
                <h1 class="title is-size-3">
                  {{ $t('modificationOrdreTravailAffichage.title', { code: ordreTravail.code }) }}
                </h1>
                <breadcrumb :breadcrumb="breadcrumb"/>
              </div>
            </div>
          </div>
          <div class="level-right">
            <a class="button" @click="$router.go(-1)">
              {{ $t('modificationOrdreTravailAffichage.actions.cancel') }}
            </a>
            <a class="button is-addOrEdit mgl-10px"
               @click="checkPermissions(permOrdreTravail.maj) ? updateOrdreTravail()
                  : showPopUp()">
              {{ $t('general.button.sauvegarder') }}
            </a>
            <piece-jointe-button
              class="mgl-10px"
              :perm="permOrdreTravail.maj">
            </piece-jointe-button>
          </div>
        </div>
      </div>
    </div>
    <error-msg-component :messages="error" class="mgt-20px"
    :error="error.length > 0"
    :title="'general.problemOccurred'"
    :withEmplyFields="true"
    @close="error = []"/>
    <div>
      <ordre-travail-update :ordreTravail="ordreTravail"
      @otAffichageDateChange="otAffichageDateChange"
      @preapreAffichageFaceUpdate="preapreAffichageFaceUpdate($event)"
      :ordreByFace="ordreByFace">
      </ordre-travail-update>
    </div>
    <div class="card mgt-20px">
      <header class="header-card">
        <p>
          {{ $t('piecesJointes.attachments')}}
        </p>
      </header>
      <div class="card-content">
        <app-pieces-jointes :checkPermissions="true"/>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import messageErreur from '@/services/general/messageErreur';
import { get, update } from '@/api/logistique/ordreTravailAffichage';
import breadcrumb from '@/components/general/breadcrumb';
import { ORDRE_TRAVAIL } from '@/configuration/logistique/permissionsLogistiqueConf';
import ordreTravailUpdate from '@/components/logistique/ordreTravail/affichage/ordreTravailAffichageUpdate';
import messageSucces from '@/services/general/messageSucces';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import validation from '@/services/logistique/ordreTravail/affichage/validation';
import validationGeneral from '@/services/validation/validation';
import * as types from '@/store/modules/logistique/ordreTravailAffichage-mutation-type';
import pieceJointeButton from '@/components/general/button/pieceJointeButton';
import PiecesJointes from '@/components/general/piecesJointes';
import formatDate from '@/services/general/formatIsoDate';
import gestionDateBase from '@/services/general/gestionDateBase';
import cloneDeep from 'lodash/cloneDeep';

const permissions = createNamespacedHelpers('permissions');
const ot = createNamespacedHelpers('ordreTravailAff');
const Attachments = createNamespacedHelpers('attachments');

export default {
  name: 'm_ordreTravail',
  data() {
    return {
      permOrdreTravail: ORDRE_TRAVAIL,
      ordreTravail: null,
      error: [],
      ordreByFace: [],
    };
  },
  components: {
    breadcrumb,
    ordreTravailUpdate,
    errorMsgComponent,
    pieceJointeButton,
    appPiecesJointes: PiecesJointes,
  },
  methods: {
    ...permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...ot.mapMutations({
      setOtCourant: types.SET_OT_COURANT,
    }),
    ...Attachments.mapActions({
      setAttachmentContext: 'setContext',
      setAttachmentElementId: 'setElementId',
      updateAttachments: 'update',
    }),
    otAffichageDateChange(dateDepart) {
      this.ordreTravail.dateDepart = dateDepart;
    },
    async updateOrdreTravail() {
      this.error = [];
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.ordreTravail.faces = this.ordreTravail.faces.map(face => {
          const ordreByFace = this.ordreByFace.find(ordreFace => {
            return face.faceId === ordreFace.faceId;
          });
          if (ordreByFace) {
            face.ordre = ordreByFace.value;
          }
          return face;
        });
        const otASauvegarder = cloneDeep(this.ordreTravail);
        otASauvegarder.dateDepart = formatDate(otASauvegarder.dateDepart);
        await update(otASauvegarder);
        await this.updateAttachments(otASauvegarder.id);
        messageSucces(this.$t('modificationOrdreTravailAffichage.messages.success.otSave'));
        loadingComponent.close();
        await this.$router.push({
          name: 'c.logistique.ordre_travail-affichage',
          params: { id: this.ordreTravail.id },
        });
      } catch (e) {
        if (e.response && e.response.data && e.response.data.error) {
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.error, this.messagesChampsVide, null);
          validation(e.response, this.error);
          loadingComponent.close();
          return;
        }
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
    preapreAffichageFaceUpdate(data) {
      this.ordreTravail.faces = this.ordreTravail
        .faces.map(face => {
          const faceToUpdate = data.find(f => f.faceId === face.faceId);
          if (faceToUpdate) {
            face.grattage = faceToUpdate.grattage;
            face.affichage = faceToUpdate.affichage;
            face.laisserEnPlace = faceToUpdate.laisserEnPlace;
            face.commentaireAffichage = faceToUpdate.commentaireAffichage;
            face.commentaireLaisserEnPlace = faceToUpdate.commentaireLaisserEnPlace;
          }
          return face;
        });
    },
  },
  destroyed() {
    if ([
      'm.logistique.ordre_travail-affichage',
      'c.logistique.ordre_travail-affichage',
      'l.logistique.ordre_travail-affichage',
    ]
      .includes(this.$route.name)) {
      this.setOtCourant(null);
    }
  },
  computed: {
    ...ot.mapGetters({
      otCourant: 'ordreTravailAffichageCourant',
    }),
    breadcrumb() {
      return [
        { title: this.$t('modificationOrdreTravailAffichage.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('modificationOrdreTravailAffichage.breadcrumb.ordreTravail'), route: { name: 'l.logistique.ordre_travail-affichage' }, isActive: false },
        { title: this.$t('modificationOrdreTravailAffichage.breadcrumb.detailOrdreTravailAffichage'), route: { name: 'c.logistique.ordre_travail-affichage', params: { id: this.ordreTravail.id } }, isActive: false },
        { title: this.$t('modificationOrdreTravailAffichage.breadcrumb.title', { code: this.ordreTravail.code }), route: '', isActive: true },
      ];
    },
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      if (this.otCourant) {
        this.ordreTravail = this.otCourant;
        this.setOtCourant(null);
      } else {
        await this.setAttachmentContext({ module: 'OrdreTravail' });
        await this.setAttachmentElementId({ id: this.$route.params.id });
        this.ordreTravail = (await get(this.$route.params.id)).data.result;
        this.ordreTravail.dateDepart = gestionDateBase(this.ordreTravail.dateDepart);
      }
      this.setInformationPage(this.$t('pageGeneral.modification', { item: this.ordreTravail.code }));
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      throw e;
    } finally {
      loadingComponent.close();
    }
    // l'alternance de couleur des lignes du tableau se fait par materiel
    const materielsIds = [...new Set(this.ordreTravail.faces.map(f => f.materielId))];
    materielsIds.forEach(matId => {
      const pair = materielsIds.indexOf(matId) % 2 === 0;
      const pairImpair = pair ? 'ot-tab-col-pair' : 'ot-tab-col-impair';
      this.ordreTravail.faces.filter(f => f.materielId === matId)
        .forEach(f => {
          f.pairImpair = pairImpair;
        });
    });
    this.ordreByFace = cloneDeep(this.ordreTravail.faces)
      .map(face => ({ faceId: face.faceId, value: face.ordre }));
  },
};
</script>

<style scoped>

</style>
